<template>
  <div class="top-bar top-bar-click">
    <div class="top-bar__right">
      <img :src="Logo" alt="Icon" class="none-mobile" />
      <img :src="TextLogo" alt="Icon" class="none-mobile" />
    </div>
    <div class="top-bar__left w100 justify-evenly">
      <!-- <div
        v-if="refreshTokenStorage || refreshToken"
        class="top-bar__row col-mobile"
      >
        <img :src="Level" alt="Icon" />
        <p class="top-bar__text font15">مرحله {{ prizeThreshold }}</p>
      </div> -->

      <div class="top-bar__row col-mobile ten-heart-click">
        <img
          :src="
            numberOfPrizes === 1
              ? Heart1
              : numberOfPrizes === 2
                ? Heart2
                : Heart3
          "
          alt="Icon"
        />
        <p class="top-bar__text font15">5 سوت طلا</p>
      </div>

      <!-- <div
        v-if="refreshTokenStorage || refreshToken"
        class="top-bar__row col-mobile"
      >
        <img :src="Envelope" alt="Icon" />
        <p class="top-bar__text font15">{{ inviteesCount }} نفر</p>
      </div> -->
    </div>
  </div>
  <Transition name="fade">
    <UserInfo
      v-if="showInfo || user.isShowNavbarItems"
      :prize-threshold="prizeThreshold"
      @close-info="closeInfo"
    />
  </Transition>

  <Transition name="fade">
    <GameInfo v-if="isShowGameInfo" @close-info="isShowGameInfo = false" />
  </Transition>
</template>

<script setup>
import Logo from '~/assets/images/taline-logo.svg'
import TextLogo from '~/assets/images/taline-text.svg'
import Heart1 from '~/assets/images/heart1.svg'
import Heart2 from '~/assets/images/heart2.svg'
import Heart3 from '~/assets/images/heart3.svg'
import Envelope from '~/assets/images/envelope.png'
import Level from '~/assets/images/level.svg'

const user = useUserStore()

const auth = useAuthStore()

const showInfo = ref(false)

const isShowGameInfo = ref(false)

const RuntimeConfig = useRuntimeConfig()

const refreshTokenStorage = localStorage.getItem(
  `taline-mini-game-${RuntimeConfig.public.GAME_VALUE}-refresh-token`,
)

const refreshToken = computed(() => auth.refreshToken)

const prizeThreshold = computed(() => user.prizeThreshold)

const numberOfPrizes = computed(() => user.numberOfPrizes)

const inviteesCount = computed(() => {
  return user.user?.userGame?.inviteesCount
})

const openInfo = () => {
  if (refreshToken.value || refreshTokenStorage) {
    showInfo.value = true
  }
}

const closeInfo = () => {
  showInfo.value = false
  user.isShowNavbarItems = false
}
</script>

<style lang="scss" scoped>
.top-bar {
  background-color: #fcfcfd;
  border-radius: 20px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  box-shadow: 1px 1px 0px 0px rgba(0, 0, 0, 0.1);
  width: calc(100% - 20px);
  max-width: $md;
  margin: 0 auto;
  border-bottom: 7px solid #4c2863;

  @media screen and (max-width: 768px) {
    height: 88px;
    max-width: $sm;
  }

  &__right,
  &__left,
  &__row {
    display: flex;
    align-items: center;
  }
  &__text {
    color: $talineContentSecondary;
    font-weight: 900;
    font-size: 24px;
    // font-family: Croissant;
  }

  &__row {
    gap: 10px;
    @media screen and (max-width: 768px) {
      gap: 5px;
    }
  }

  &__left {
    gap: 30px;
  }
}
</style>
